var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPptFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.502 10.007h-2.104V15.4h-1.322v-5.393H9.999V9h5.503v1.007ZM6.603 13.053V15.4H5.286V9H7.62c.372 0 .708.051 1.008.154.3.1.556.239.769.417.209.182.37.399.482.651.116.252.174.532.174.84a1.829 1.829 0 0 1-.656 1.424 2.31 2.31 0 0 1-.77.417c-.3.1-.635.15-1.007.15H6.603Zm0-1.003H7.62c.188 0 .35-.026.487-.079a1.01 1.01 0 0 0 .347-.215.866.866 0 0 0 .202-.312c.047-.12.07-.245.07-.374 0-.15-.023-.288-.07-.417a.922.922 0 0 0-.202-.339.997.997 0 0 0-.347-.228 1.295 1.295 0 0 0-.487-.084H6.603v2.048ZM1.317 13.053V15.4H0V9h2.334c.372 0 .708.051 1.008.154.3.1.556.239.769.417.21.182.37.399.483.651.115.252.173.532.173.84a1.83 1.83 0 0 1-.656 1.424 2.31 2.31 0 0 1-.769.417c-.3.1-.636.15-1.008.15H1.317Zm0-1.003h1.017c.188 0 .35-.026.488-.079a1.01 1.01 0 0 0 .347-.215.867.867 0 0 0 .201-.312c.047-.12.07-.245.07-.374 0-.15-.023-.288-.07-.417a.922.922 0 0 0-.201-.339.997.997 0 0 0-.347-.228 1.295 1.295 0 0 0-.488-.084H1.317v2.048Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 4.5V8h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v6H2V2a2 2 0 0 1 2-2h5.5L14 4.5Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptFile);
export default __webpack_public_path__ + "static/media/ppt-file.bfcfd790570e4001a49b22ae087bf129.svg";
export { ForwardRef as ReactComponent };